// http://157.175.90.166:8080

import HTTP from "../services/http.service";

var EligibilityService = {};

EligibilityService.getCheckEligiblity = () => {
    let config = {
        method: "get",
        url: "/user_identy/check_eligability",
    };
    return HTTP(config);
};



export default EligibilityService;
